import { apiClient } from "./apiClient";

/**
 * Download MIS Report
 * Makes real API call to download specific MIS report data
 * @param {string} reportType - Type of report
 * @param {Object} params - Additional parameters
 * @param {string} apiUrl - API endpoint URL
 * @returns {Promise} API response with report data
 */
export const downloadMISReport = async (reportType, params = {}, apiUrl) => {
  try {
    if (!apiUrl) {
      throw new Error(`API URL not provided for ${reportType} report`);
    }

    // Prepare query parameters
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key] !== undefined && params[key] !== null) {
        queryParams.append(key, params[key]);
      }
    });

    // Build full URL with query parameters
    const fullUrl = queryParams.toString()
      ? `${apiUrl}?${queryParams.toString()}`
      : apiUrl;

    // Make API call using apiClient
    const response = await apiClient.get(fullUrl);

    // apiClient returns axios response, so we need to extract data
    return {
      success: true,
      data: response.data,
      message: `${reportType} report data fetched successfully`,
    };
  } catch (error) {
    console.error(`Error downloading ${reportType} report:`, error);

    return {
      success: false,
      error: error.message,
      message: `Failed to download ${reportType} report: ${error.message}`,
    };
  }
};

// Export all API functions
const apiService = {
  downloadMISReport,
};

export default apiService;
